import classnames from 'classnames';
import * as React from 'react';
import { Transition, TransitionGroup } from 'react-transition-group';
import { NotificationsContext, isNotification } from './context.js';
import { MessageComponent } from './message_component.js';
import { wrapper, messages, ANIMATION_DURATION_MS, container, global, notifications, content } from './notifications.css.js';

const TransistionWithRef = (props) => {
    const ref = React.useRef(null);
    return (React.createElement(Transition, { ...props, nodeRef: ref }, props.children));
};
const NotificationBoundary = ({ className, style, children }) => {
    const announcements = React.useRef(new Map());
    const notifications$1 = React.useRef(new Map());
    const [, setLastUpdated] = React.useState(0);
    const parentContext = React.useContext(NotificationsContext);
    const isTopMostContext = parentContext.isTopMost === null;
    const context = React.useMemo(() => {
        const newContext = {
            isTopMost: isTopMostContext,
            send: (message) => {
                if (isNotification(message)) {
                    notifications$1.current.set(message.key, message);
                }
                else {
                    announcements.current.set(message.key, message);
                }
                setLastUpdated((prevValue) => prevValue + 1);
                return message.key;
            },
            sendTopMost: (message) => {
                if (!isTopMostContext) {
                    return parentContext.sendTopMost(message) ?? message.key;
                }
                return newContext.send(message);
            },
            dismiss: (key) => {
                announcements.current.delete(key);
                notifications$1.current.delete(key);
                setLastUpdated((prevValue) => prevValue + 1);
            },
            dismissTopMost: (key) => {
                if (!isTopMostContext) {
                    return parentContext.dismissTopMost(key);
                }
                return newContext.dismiss(key);
            },
        };
        return newContext;
    }, [parentContext, isTopMostContext, setLastUpdated]);
    const latestAnnouncement = Array.from(announcements.current.values()).pop();
    const notificationsList = Array.from(notifications$1.current.values());
    const classNameObject = typeof className === 'string' ? undefined : className;
    const classNameString = typeof className === 'string' ? className : undefined;
    return (React.createElement("div", { className: classnames(wrapper, classNameObject?.wrapper ?? classNameString), style: style },
        React.createElement(TransitionGroup, { "data-testid": "notification-boundary-announcement-container", className: classnames(messages, classNameObject?.messages), exit: true, appear: true }, latestAnnouncement !== undefined && (React.createElement(TransistionWithRef, { key: latestAnnouncement.key, timeout: ANIMATION_DURATION_MS }, (status) => (React.createElement(MessageComponent, { transitionStatus: status, message: latestAnnouncement, onRequestDismiss: context.dismiss, closable: latestAnnouncement.closable ?? false, onCloseClick: latestAnnouncement.onCloseClick }))))),
        React.createElement("div", { className: classnames(container, classNameObject?.container) },
            React.createElement(TransitionGroup, { "data-testid": "notification-boundary-notifications-container", className: classnames({ [notifications]: true, [global]: isTopMostContext }, classNameObject?.notifications), exit: true, appear: true }, notificationsList.map((notification) => (React.createElement(TransistionWithRef, { key: notification.key, timeout: ANIMATION_DURATION_MS }, (status) => (React.createElement(MessageComponent, { transitionStatus: status, message: notification, onRequestDismiss: context.dismiss })))))),
            React.createElement("div", { className: classnames(content, classNameObject?.content) },
                React.createElement(NotificationsContext.Provider, { value: context }, children)))));
};

export { NotificationBoundary };
